(function () {
  if (window.__kkProductReviewsLazyLoaded) return;
  window.__kkProductReviewsLazyLoaded = true;

  var SECTION_SELECTOR = '[data-kk-product-reviews-lazy]';
  var BADGE_SELECTOR = '.product-main .jdgm-preview-badge';
  var JUDGEME_MAX_ATTEMPTS = 20;
  var JUDGEME_RETRY_DELAY = 250;
  var JUDGEME_CSS_TIMEOUT = 5000;
  var JUDGEME_SCRIPT_TIMEOUT = 10000;
  var judgeMeCssPromises = {};
  var judgeMeReviewModulesPromise = null;

  function isJudgeMeStylesheet(link, assetName) {
    var href = link && link.href ? String(link.href) : '';

    return href.indexOf('/widget_v3/' + assetName) !== -1
      || href.indexOf('/widget/' + assetName) !== -1
      || href.indexOf('/widget_v3_' + assetName) !== -1;
  }

  function waitForStylesheet(link) {
    return new Promise(function (resolve, reject) {
      var timeout;
      var settled = false;

      function finish(error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        link.removeEventListener('load', handleLoad);
        link.removeEventListener('error', handleError);

        if (error) {
          reject(error);
        } else {
          resolve(link);
        }
      }

      function handleLoad() {
        finish();
      }

      function handleError() {
        finish(new Error('Judge.me review stylesheet failed to load.'));
      }

      if (link.sheet) {
        resolve(link);
        return;
      }

      link.addEventListener('load', handleLoad, { once: true });
      link.addEventListener('error', handleError, { once: true });
      timeout = window.setTimeout(function () {
        finish(new Error('Judge.me review stylesheet timed out.'));
      }, JUDGEME_CSS_TIMEOUT);
    });
  }

  function loadJudgeMeStylesheet(assetName) {
    var existing;

    if (judgeMeCssPromises[assetName]) {
      return judgeMeCssPromises[assetName];
    }

    existing = Array.prototype.find.call(
      document.querySelectorAll('link[rel="stylesheet"]'),
      function (link) {
        return isJudgeMeStylesheet(link, assetName);
      }
    );

    if (existing) {
      judgeMeCssPromises[assetName] = waitForStylesheet(existing);
    } else {
      judgeMeCssPromises[assetName] = new Promise(function (resolve, reject) {
        var settled = false;
        var timeout = window.setTimeout(function () {
          if (settled) return;
          settled = true;
          reject(new Error('Judge.me stylesheet timed out: ' + assetName));
        }, JUDGEME_CSS_TIMEOUT);

        try {
          window.jdgm.loadCSS(window.jdgm.widgetPath(assetName), function () {
            if (settled) return;
            settled = true;
            window.clearTimeout(timeout);
            resolve();
          });
        } catch (error) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeout);
          reject(error);
        }
      });
    }

    judgeMeCssPromises[assetName] = judgeMeCssPromises[assetName].catch(function (error) {
      delete judgeMeCssPromises[assetName];
      throw error;
    });

    return judgeMeCssPromises[assetName];
  }

  function loadJudgeMeReviewStyles() {
    return Promise.all([
      loadJudgeMeStylesheet('main.css'),
      loadJudgeMeStylesheet('media.css'),
      loadJudgeMeStylesheet('form.css')
    ]);
  }

  function wasJudgeMeModuleRequested(modulePath) {
    var requestedUrls = window.jdgm
      && window.jdgm.loadScript
      && window.jdgm.loadScript.requestedUrls;
    var flattenedPath = modulePath.replace(/\//g, '_');

    if (!requestedUrls || !requestedUrls.some) return false;

    return requestedUrls.some(function (url) {
      url = String(url || '');
      return url === modulePath
        || url.indexOf(modulePath) !== -1
        || url.indexOf(flattenedPath) !== -1;
    });
  }

  function loadJudgeMeModule(modulePath, isReady) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var pollTimer = 0;
      var timeoutTimer = 0;

      function finish(error) {
        if (settled) return;
        settled = true;
        window.clearInterval(pollTimer);
        window.clearTimeout(timeoutTimer);

        if (error) {
          reject(error);
        } else {
          resolve();
        }
      }

      function checkReady() {
        if (isReady()) finish();
      }

      if (isReady()) {
        resolve();
        return;
      }

      pollTimer = window.setInterval(checkReady, 50);
      timeoutTimer = window.setTimeout(function () {
        finish(new Error('Judge.me module timed out: ' + modulePath));
      }, JUDGEME_SCRIPT_TIMEOUT);

      try {
        // Judge.me suppresses duplicate requests without invoking the callback.
        // Force only a previously requested module that is still unavailable so
        // a failed code-split request can recover when the customer retries.
        window.jdgm.loadScript(
          modulePath,
          checkReady,
          wasJudgeMeModuleRequested(modulePath)
        );
      } catch (error) {
        finish(error);
      }
    });
  }

  function loadJudgeMeReviewModules() {
    var mainModule;
    var mediaModule;
    var modalModule;
    var formModule;

    if (judgeMeReviewModulesPromise) {
      return judgeMeReviewModulesPromise;
    }

    // A review fragment inserted after Judge.me's initial page scan does not
    // trigger its code-splitting loader. Main must be ready first. Media can
    // then load in parallel with the modal -> form dependency chain.
    mainModule = {
      path: 'widget/main.js',
      ready: function () {
        return window.jdgm._doneSetup === true
          && typeof window.jdgm._setupLoadReviewsEventsFor === 'function';
      }
    };
    mediaModule = {
      path: 'widget/media.js',
      ready: function () {
        return window.jdgm._doneLoadingMediaJs === true
          && typeof window.jdgm.setupMediaGallery === 'function';
      }
    };
    modalModule = {
      path: 'widget/write_review_modal.js',
      ready: function () {
        return typeof window.jdgm._WriteReviewModal === 'function';
      }
    };
    formModule = {
      path: 'widget/form.js',
      ready: function () {
        return typeof window.jdgm._renderAndSetupReviewForm === 'function'
          && typeof window.jdgm._setupQuestionsForm === 'function'
          && typeof window.jdgm._setupFormsSubmit === 'function';
      }
    };

    judgeMeReviewModulesPromise = loadJudgeMeModule(
      mainModule.path,
      mainModule.ready
    ).then(function () {
      return Promise.all([
        loadJudgeMeModule(mediaModule.path, mediaModule.ready),
        loadJudgeMeModule(modalModule.path, modalModule.ready).then(function () {
          return loadJudgeMeModule(formModule.path, formModule.ready);
        })
      ]);
    }).catch(function (error) {
      judgeMeReviewModulesPromise = null;
      throw error;
    });

    return judgeMeReviewModulesPromise;
  }

  function extendJudgeMeCaches(target) {
    var $target = window.jdgm.$(target);
    var caches = window.jdgm.caches = window.jdgm.caches || {};
    var widgetWithReviews = $target.find(
      '.jdgm-review-widget, .jdgm-revs-tab, .jdgm-all-reviews-widget'
    );
    var reviewWidgets = $target.find(
      '.jdgm-review-widget, [data-widget="review"]'
    );

    caches.$widgetWithReviews = caches.$widgetWithReviews
      && typeof caches.$widgetWithReviews.add === 'function'
      ? caches.$widgetWithReviews.add(widgetWithReviews)
      : widgetWithReviews;
    caches.$revWidgets = caches.$revWidgets
      && typeof caches.$revWidgets.add === 'function'
      ? caches.$revWidgets.add(reviewWidgets)
      : reviewWidgets;
  }

  function initSection(section) {
    if (!section || section.dataset.kkProductReviewsInitialized === 'true') return;

    var target = section.querySelector('[data-kk-product-reviews-target]');
    var placeholder = section.querySelector('[data-kk-product-reviews-placeholder]');
    var trigger = section.querySelector('[data-kk-product-reviews-trigger]');
    var status = section.querySelector('[data-kk-product-reviews-status]');
    var productBadge = document.querySelector(BADGE_SELECTOR);
    var preloadDistance = Number(section.dataset.preloadDistance) || 800;
    var loadingLabel = section.dataset.loadingLabel || 'Ladataan tuotearvosteluja';
    var readyLabel = section.dataset.readyLabel || 'Tuotearvostelut ladattu';
    var errorLabel = section.dataset.errorLabel || 'Arvostelujen lataaminen epäonnistui. Yritä uudelleen.';
    var reviewsUrl = section.dataset.reviewsUrl;
    var triggerLabel = trigger ? trigger.textContent : '';
    var observer = null;
    var judgeMeTimer = 0;
    var activeRequest = null;
    var loaded = false;
    var fragmentLoaded = false;
    var destroyed = false;

    if (!reviewsUrl || !target) return;

    preloadDistance = Math.min(1200, Math.max(400, preloadDistance));
    section.dataset.kkProductReviewsInitialized = 'true';

    function setStatus(message) {
      if (status) status.textContent = message;
    }

    function disconnectObserver() {
      if (!observer) return;
      observer.disconnect();
      observer = null;
    }

    function scrollToReviews() {
      var reducedMotion = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      section.scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    }

    function setReviewWidgetsVisible(visible) {
      target.querySelectorAll('.jdgm-rev-widg').forEach(function (widget) {
        widget.hidden = !visible;
        if (visible) {
          widget.removeAttribute('aria-hidden');
        } else {
          widget.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function removeJudgeMeTemporaryHidingStyles() {
      target.querySelectorAll('.jdgm-temp-hiding-style').forEach(function (style) {
        style.remove();
      });
    }

    function verifyReviewWidgetVisible() {
      return new Promise(function (resolve, reject) {
        window.requestAnimationFrame(function () {
          var widget = target.querySelector('.jdgm-rev-widg');
          var visible = widget
            && window.getComputedStyle(widget).display !== 'none'
            && widget.getBoundingClientRect().height > 0;

          if (visible) {
            resolve();
          } else {
            reject(new Error('Judge.me review widget remained hidden after initialization.'));
          }
        });
      });
    }

    function restoreRetryState(error, warningMessage) {
      if (destroyed) return;

      if (judgeMeTimer) {
        window.clearTimeout(judgeMeTimer);
        judgeMeTimer = 0;
      }

      loaded = false;
      section.dataset.reviewsState = 'error';
      section.setAttribute('aria-busy', 'false');
      setStatus(errorLabel);
      setReviewWidgetsVisible(false);

      if (placeholder) placeholder.hidden = false;
      if (trigger) {
        trigger.disabled = false;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.textContent = triggerLabel;
      }

      if (warningMessage) console.warn(warningMessage, error);
    }

    function finishLoading() {
      if (destroyed) return;

      judgeMeTimer = 0;
      setReviewWidgetsVisible(true);
      if (placeholder) placeholder.hidden = true;
      section.dataset.reviewsState = 'ready';
      section.setAttribute('aria-busy', 'false');
      setStatus(readyLabel);
      section.dispatchEvent(new CustomEvent('kiekkokingi:reviews-ready', { bubbles: true }));
    }

    function requestReviews() {
      return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        activeRequest = request;
        request.open('GET', reviewsUrl, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.onload = function () {
          activeRequest = null;
          if (request.status >= 200 && request.status < 300) {
            resolve(request.responseText);
          } else {
            reject(new Error('HTTP ' + request.status));
          }
        };
        request.onerror = function () {
          activeRequest = null;
          reject(new Error('Network request failed'));
        };
        request.onabort = function () {
          activeRequest = null;
          reject(new Error('Request aborted'));
        };
        request.send();
      });
    }

    function initializeJudgeMe(attempt, lastError) {
      var judgeMeReady;

      if (destroyed) return;

      judgeMeReady = window.jdgm
        && typeof window.jdgm.initializeWidgets === 'function'
        && typeof window.jdgm.$ === 'function'
        && typeof window.jdgm.widgetPath === 'function'
        && typeof window.jdgm.loadCSS === 'function'
        && typeof window.jdgm.loadScript === 'function';

      if (judgeMeReady) {
        Promise.all([
          loadJudgeMeReviewStyles(),
          loadJudgeMeReviewModules()
        ]).then(function () {
          if (destroyed) return;

          extendJudgeMeCaches(target);
          return Promise.resolve(
            window.jdgm.initializeWidgets(window.jdgm.$(target))
          ).then(function () {
            if (destroyed) return;
            removeJudgeMeTemporaryHidingStyles();
            setReviewWidgetsVisible(true);
            return verifyReviewWidgetVisible();
          });
        }).then(function () {
          finishLoading();
        }).catch(function (error) {
          restoreRetryState(
            error,
            'KiekkoKingi reviews: Judge.me initialization failed.'
          );
        });
        return;
      }

      if (attempt >= JUDGEME_MAX_ATTEMPTS) {
        restoreRetryState(
          lastError || new Error('Judge.me API was not available in time.'),
          'KiekkoKingi reviews: Judge.me initialization failed.'
        );
        return;
      }

      judgeMeTimer = window.setTimeout(function () {
        judgeMeTimer = 0;
        initializeJudgeMe(attempt + 1, lastError);
      }, JUDGEME_RETRY_DELAY);
    }

    function loadReviews(options) {
      var shouldScroll = options && options.scroll === true;

      if (loaded) {
        if (shouldScroll) scrollToReviews();
        return;
      }

      loaded = true;
      disconnectObserver();
      section.dataset.reviewsState = 'loading';
      section.setAttribute('aria-busy', 'true');
      setStatus(loadingLabel);

      if (trigger) {
        trigger.disabled = true;
        trigger.setAttribute('aria-expanded', 'true');
        trigger.textContent = loadingLabel;
      }

      if (shouldScroll) {
        window.requestAnimationFrame(scrollToReviews);
      }

      if (fragmentLoaded && target.querySelector('.jdgm-rev-widg')) {
        setReviewWidgetsVisible(false);
        window.requestAnimationFrame(function () {
          initializeJudgeMe(0);
        });
        return;
      }

      requestReviews().then(function (html) {
        if (destroyed) return;
        target.innerHTML = html;
        fragmentLoaded = true;
        setReviewWidgetsVisible(false);
        window.requestAnimationFrame(function () {
          initializeJudgeMe(0);
        });
      }).catch(function (error) {
        restoreRetryState(
          error,
          'KiekkoKingi reviews: review widget request failed.'
        );
      });
    }

    function handleTriggerClick() {
      loadReviews({ scroll: false });
    }

    function handleBadgeClick(event) {
      if (loaded) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      loadReviews({ scroll: true });
    }

    function handleBadgeKeydown(event) {
      if (loaded || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      loadReviews({ scroll: true });
    }

    if (trigger) trigger.addEventListener('click', handleTriggerClick);
    if (productBadge) {
      productBadge.addEventListener('click', handleBadgeClick, true);
      productBadge.addEventListener('keydown', handleBadgeKeydown, true);
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          loadReviews({ scroll: false });
        }
      }, {
        rootMargin: preloadDistance + 'px 0px',
        threshold: 0
      });
      observer.observe(section);
    } else {
      loadReviews({ scroll: false });
    }

    section.__kkProductReviewsCleanup = function () {
      destroyed = true;
      disconnectObserver();
      if (judgeMeTimer) window.clearTimeout(judgeMeTimer);
      if (activeRequest) activeRequest.abort();
      if (trigger) trigger.removeEventListener('click', handleTriggerClick);
      if (productBadge) {
        productBadge.removeEventListener('click', handleBadgeClick, true);
        productBadge.removeEventListener('keydown', handleBadgeKeydown, true);
      }
      delete section.__kkProductReviewsCleanup;
    };
  }

  function initWithin(root) {
    if (!root) return;
    if (root.matches && root.matches(SECTION_SELECTOR)) initSection(root);
    if (root.querySelectorAll) root.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  initWithin(document);

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches && event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector && event.target.querySelector(SECTION_SELECTOR);
    if (section && section.__kkProductReviewsCleanup) section.__kkProductReviewsCleanup();
  });
})();
